export const FETCH_SHIPPERPROF_ACTION = "FETCH_SHIPPERPROF_ACTION";
export const FETCH_SHIPPERPROF_FAIL_ACTION = FETCH_SHIPPERPROF_ACTION + "_ERROR";
export const FETCH_SHIPPERPROF_SUCCESS_ACTION = FETCH_SHIPPERPROF_ACTION + "_SUCCESS";

export const UPDATE_PROF_IMAGE_INIT = "UPDATE_PROF_IMAGE_INIT";
export const UPDATE_PROF_IMAGE_SUCCESS = UPDATE_PROF_IMAGE_INIT+"_SUCCESS";
export const UPDATE_PROF_IMAGE_FAIL = UPDATE_PROF_IMAGE_INIT+"_FAIL";